import React, { createRef } from 'react';

import { Container } from 'react-bootstrap';
import { Context, ContextWatchdog, DecoupledEditor } from 'ckeditor5';
import { CKEditor, CKEditorContext } from '@ckeditor/ckeditor5-react';

import { EncodeSignatures, validSignatories } from '../../../System/WorkApproval/pages/other/helpers';

import moment from 'moment';

import ComponentBlocker from '../../../Component/Custom/ComponentBlocker'

import 'ckeditor5/ckeditor5.css';

// import PDFMake from 'pdfmake';

const chunkArray = (array, chunkSize) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
};

class CustomCKEditor extends React.Component {

    refCkEditor = createRef(null);
    refPrintingFrame = createRef(null);

    constructor() {
        super();
        
        this.state = {
            isNotReady: true,
            editorData: ''
        };
    }

    componentDidMount () {
        if (this.props?.value) {
            this.setState({
                editorData: this.props.value || ''
            });
        }
    }

    render() {

        return (
            <ComponentBlocker
                blocked={this.isNotReady}
                variant="light"
                color="dark"
            >
                <Container fluid className='px-0'>
                    <CKEditorContext
                        context={Context}
                        contextWatchdog={ContextWatchdog}
                    >
                        <div className="d-flex flex-column rich-editor">

                            {
                                this.props?.enabled && (
                                    <div
                                        className="wack-toolbar-container"
                                        style={{
                                            position: 'sticky',
                                            zIndex: 10,
                                            top: 0
                                        }}
                                    />
                                )
                            }

                            <div
                                className='w-100 py-0'
                                style={{
                                    overflowX: 'scroll',
                                    backgroundColor: '#eee',
                                    minHeight: 'calc(1092px / 2)'
                                }}
                            >
                                <CKEditor
                                    id="ckEditorID"
                                    ref={this.refCkEditor}
                                    editor={DecoupledEditor}
                                    config={this.props.config}
                                    disabled={!this.props?.enabled}
                                    data={this.state.editorData}
                                    onReady={
                                        editor => {
                                            if (this.props?.enabled) {
                                                const enableWordCount = editor.config.get('wordCount');

                                                if (enableWordCount) {
                                                    const wordCountPlugin = editor.plugins.get('WordCount');

                                                    const toolbarContainer = document.querySelector('.wack-toolbar-container');
                                                    const wordCountWrapper = document.getElementById('word-count');

                                                    toolbarContainer.appendChild(editor.ui.view.menuBarView.element);
                                                    toolbarContainer.appendChild(editor.ui.view.toolbar.element);

                                                    // toolbarContainer.firstElementChild.classList.add('ck-toolbar_grouping')
                                                    wordCountWrapper.appendChild(wordCountPlugin.wordCountContainer);
                                                }

                                                editor.disableReadOnlyMode('feature-id');
                                            } else {
                                                editor.enableReadOnlyMode('feature-id');
                                            }

                                            editor.listenTo(editor.ui.view, 'printWorkApprovalDocument', () => {
                                                this.onPrint();
                                            });

                                            this.setState({
                                                isNotReady: false
                                            });
                                        }
                                    }
                                    onChange={
                                        (_evt, editor) => {
                                            if (!this.props?.enabled || typeof this.props?.onChange !== 'function') {
                                                return;
                                            }

                                            this.props.onChange(editor.getData(), editor);
                                        }
                                    }
                                />
                            </div>

                            {
                                this.props?.enabled && (
                                    <div className='d-flex justify-content-end mt-3'>
                                        <div id='word-count'></div>
                                    </div>
                                )
                            }
                        </div>
                    </CKEditorContext>
                    <div>
                        <iframe
                            ref={this.refPrintingFrame}
                            aria-hidden="true"
                            tabIndex="-1"
                            title='1'
                            style={{
                                position: 'absolute',
                                // columns: '260mm',
                                // width: '260mm',
                                // height: '1092px',
                                // marginLeft: '-260mm',
                                // marginTop: '-1092px',
                                border: 0,
                                padding: 0,
                                whiteSpace: 'nowrap',
                                clipPath: 'inset(100%)',
                                clip: 'rect(0 0 0 0)',
                                overflow: 'hidden'
                            }}
                        />
                    </div>
                </Container>
            </ComponentBlocker>
        );
    }

    isMobile () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    }

    onPrint() {
        const workApprovalConfig = this.refCkEditor.current.editor.config.get('workApproval');

        if (!workApprovalConfig) {
            return;
        }

        if (typeof workApprovalConfig !== 'function') {
            return;
        }

        const workApproval = workApprovalConfig();

        if (!workApproval?.approvers) {
            return;
        }

        if (workApproval.approvers?.length <= 0) {
            return;
        }

        const signatories = EncodeSignatures(
            workApproval.approvers,
            (value, _) => value,
            validSignatories
        ).signatureInputs;

        const content = [
            String(this.refCkEditor.current.editor.getData()),
            this.tComments(workApproval.comments),
            this.tRemarks(signatories),
            this.tSignatories(signatories)
        ].join('');

        const version = Math.floor(Math.random() * 100);

        const renderHTML = (
            `
                <html class="printing">
                    <head>
                        <meta charset="utf-8" />
                        <meta name="viewport" content="width=device-width, initial-scale=1" />
                        <title>${workApproval.subject}</title>
                        <link rel="stylesheet" href="${window.location.origin}/assets/plugins/global/plugins.bundle.css" />
                        <link rel="stylesheet" href="${window.location.origin}/assets/css/style.bundle.css" />
                        <link rel="stylesheet" href="${window.location.origin}/assets/css/printing.css" />
                        <link rel="stylesheet" href="${window.location.origin}/assets/css/ckeditor.css" />
                        <link href='https://fonts.googleapis.com/css?family=Lato' rel='stylesheet' />
                    </head>
                    <body class="printing">
                        <img id="print-logo" src="${process.env.REACT_APP_API_URI}/company/company-logo-print.png?v=${version}" style="display: none;"/>
                        <div id="print-source" class="ck ck-content">
                            ${this.tHeader(workApproval)}
                            ${content}
                        </div>
                        <div id="printable-data"></div>
                        <script src="${window.location.origin}/assets/js/printing.js"></script>
                    </body>
                </html>
            `
        );

        this.refPrintingFrame.current.srcdoc = renderHTML;
    }

    tHeader(workApproval) {
        const targetDate = moment(workApproval.created_at || Date.now()).format('MMMM DD, YYYY');

        return (
            `
                <div class="page-sub-header">
                    <table class="w-100">
                        <tbody>
                            <tr>
                                <td style="width: 10%;">
                                    <b>Date</b>
                                </td>
                                <td style="width: 90%;">: ${targetDate}</td>
                            </tr>
                            <tr>
                                <td style="width: 10%;">
                                    <b>To</b>
                                </td>
                                <td style="width: 90%;">: ${workApproval.mail_to}</td>
                            </tr>
                            <tr>
                                <td style="width: 10%;">
                                    <b>From</b>
                                </td>
                                <td style="width: 90%;">: ${workApproval.mail_from}</td>
                            </tr>
                            <tr>
                                <td style="width: 10%;">
                                    <b>Subject</b>
                                </td>
                                <td style="width: 90%;">: ${workApproval.subject}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            `
        );
    }

    tRemarks(signatories) {
        const approverRemarks = signatories.filter(
            signatory => signatory.approvers.filter(
                approver => approver.remarks
            ).length > 0
        );

        if (approverRemarks.length <= 0) {
            return '';
        }

        const content = approverRemarks.map(
            signatory => {
                const valid = signatory.approvers.filter(
                    approver => approver.remarks
                );

                return valid.map(
                    approver => (
                        `
                            <p class="approver-title">
                                ${approver.first_name} ${approver.last_name}
                            </p>
                            <p>
                                ${approver.remarks}
                            </p>
                            <p style="border-bottom: 1px solid gray; text-align: right; font-size: 9.50px;">
                                ${approver.status_at ? moment(approver.status_at).format('MMM DD, YYYY - LT') : ''}
                            </p>
                        `
                    )
                ).join('')
            }
        ).join('');

        return (
            `
                <p><br data-cke-filler="true"></p>
                <p class="approver-title">Remarks</p>
                ${content}
            `
        );
    }

    tComments(comments) {
        if (comments.length <= 0) {
            return '';
        }

        const content = comments.map(
            (comment) => (
                `
                    <p class="approver-title">
                        ${comment.first_name} ${comment.last_name}
                    </p>
                    <p>
                        ${comment.remarks}
                    </p>
                    <p style="border-bottom: 1px solid gray; text-align: right; font-size: 9.50px;">
                        ${comment.created_at ? moment(comment.created_at).format('MMM DD, YYYY - LT') : ''}
                    </p>
                `
            )
        ).join('');

        return (
            `
                <p><br data-cke-filler="true"></p>
                <p class="approver-title">Comments</p>
                ${content}
            `
        );
    }

    tSignatories(signatories) {

        const signatureApprovers = signatories.map(signature => {
            signature.approvers = chunkArray(signature.approvers, 3);
            return signature;
        });

        const approverFormat = (approver, key) => (
            `
                <div class="approver-wrapper" key="${key}">
                    <div class="approver-content">
                        <div class="approver-name">${String(approver.full_name).toUpperCase()}</div>
                        <div class="fw-bold approver-position">${String(approver.position_name).toUpperCase()}</div>
                        <div class="approver-status">
                            <div>${approver.status_at ? String(moment(approver.status_at).format('MMM DD, YYYY - LT')).toUpperCase() : ''}</div>
                            <div class="${['APPROVED', 'RECEIVED'].includes(approver.status) ? 'text-success' : 'text-warning'}">${approver.status}</div>
                        </div>
                    </div>
                </div>
            `
        );

        if (signatories.length <= 0) {
            return '';
        }

        return signatureApprovers.map(
            (signature) => {
                const content = signature.approvers.map(
                    approvers => (
                        `
                            <section class="approvers" key="${signature.order}">
                                ${approvers.map(approverFormat).join('')}
                            </section>
                        `
                    )
                ).join('');

                return (
                    `
                        <p><br data-cke-filler="true"></p>
                        <p class="approver-title" key="${signature.order}">${signature.title}:</p>
                        ${content}
                    `
                );
            }
        ).join('');
    }
}

export default CustomCKEditor;
